import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {s3FeatureImagePath, THUMBNAIL_SIZES} from "../../misc/utils";
import {baseNewImagesPath} from "../assets";

const NotInVisualizerView = (props) => {

  const getThumbnail = () => {

    if (!props.activeFeature) {
      return null
    }

    let src = "";
    let styles = {};
    if (props.activeFeature.dbFeature.thumbnailUrl) {
      src = s3FeatureImagePath(
        props.activeFeature.dbFeature,
        props.isMobile ? THUMBNAIL_SIZES.small : THUMBNAIL_SIZES.medium
      );
    } else if (props.currentFeature && props.activeFeature.customThumbnail) {
      src = props.activeFeature.customThumbnail;
    } else {
      src = `${baseNewImagesPath}images/image-not-found.png`;
    }
    // if (props.isMobile) {
    //   const height = (props.listItemHeight - 32) / 2;
    //   styles.height = height;
    //   styles.width = height;
    // }
    // console.log("listItemHeight", );
    return (
      <div className="not-in-visualizer-thumbnail" style={styles}>
        <img src={src} alt="not-in-visualizer-thumbnail" className={"not-in-visualizer-thumbnail__image"}/>
      </div>
    )
  }

  if (props.allVisualizerNotAvailable) {
    return (
      <div className="not-in-visualizer not-in-visualizer--visualizer-not-available">
        {getThumbnail()}
        <span className="not-in-visualizer-title">
          <FormattedMessage id="quotingTool.canvas.visualizerNotAvailableTitle"/>
        </span>
        <p className="not-in-visualizer-text">
          <FormattedMessage id="quotingTool.canvas.visualizerNotAvailableText"/>
        </p>
      </div>
    )
  }

  const notAvailableAtAll = !props.activeFeature.dbFeature.s3Bindings || !props.activeFeature.dbFeature.s3Bindings.length;

  return !notAvailableAtAll ? (
    <div className="not-in-visualizer">
      <span className="not-in-visualizer-expand" onClick={props.goToBV}/>
      <span className="not-in-visualizer-text not-in-visualizer-text--wide">
        <FormattedMessage id="quotingTool.canvas.featureNotCompatibleMessage"/>
      </span>
    </div>
  ) : (
    <div className="not-in-visualizer">
      {getThumbnail()}
      <span className="not-in-visualizer-title">
        <FormattedMessage id="quotingTool.canvas.featureNotAvailableTitle"/>
      </span>
      <p className="not-in-visualizer-text">
        <FormattedMessage id="quotingTool.canvas.featureNotAvailableText"/>
      </p>
    </div>
  )
};

NotInVisualizerView.displayName = "NotInVisualizerView";
NotInVisualizerView.propTypes = {
  goToBV: PropTypes.func,
  activeFeature: PropTypes.object,
  allVisualizerNotAvailable: PropTypes.bool,
};
export default NotInVisualizerView
